import React from 'react';
import './DateCheckbox.css';

const DateCheckbox = ({ 
  checked,
  onChange,
  disabled = false,
}) => {
  return (
    <div className="date-checkbox">
      <label className="date-checkbox__container">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className="date-checkbox__input"
        />
        <span className="date-checkbox__checkmark"></span>
      </label>
    </div>
  );
};

export default DateCheckbox; 